import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel", "companion"]

  connect() {
    this.showTab(this.initialIndex())
  }

  select(event) {
    event.preventDefault()
    const index = this.tabTargets.indexOf(event.currentTarget)
    this.showTab(index)
    // Keep the open tab in the URL so a refresh restores it
    const name = event.currentTarget.dataset.tabsName
    if (name) history.replaceState(null, "", `#${name}`)
  }

  showTab(index) {
    this.tabTargets.forEach((tab, i) => {
      tab.classList.toggle("profile-tabs__tab--active", i === index)
    })
    this.panelTargets.forEach((panel, i) => {
      panel.style.display = i === index ? "" : "none"
    })
    // Companions live outside the panel list (e.g. below the form) but
    // belong to a named tab: data-tabs-companion matches data-tabs-name
    const activeName = this.tabTargets[index]?.dataset.tabsName
    this.companionTargets.forEach((el) => {
      el.style.display = el.dataset.tabsCompanion === activeName ? "" : "none"
    })
  }

  // The hash names a tab directly (#qr), or deep-links content owned
  // by a tab's companion (#tracked-qr-codes)
  initialIndex() {
    const hash = window.location.hash.slice(1)
    if (!hash) return 0

    const byName = this.tabTargets.findIndex((tab) => tab.dataset.tabsName === hash)
    if (byName >= 0) return byName

    const companion = this.companionTargets.find(
      (el) => el.id === hash || el.querySelector(`#${CSS.escape(hash)}`)
    )
    if (companion) {
      const index = this.tabTargets.findIndex(
        (tab) => tab.dataset.tabsName === companion.dataset.tabsCompanion
      )
      if (index >= 0) return index
    }
    return 0
  }
}
